import React from "react";
import css from './index.css';
import TestPicturesWall from './TestPicturesWall';
import getSize from "../../../utils/getSize";
import {Scrollbars} from 'react-custom-scrollbars';

export default class PicturesWallContainer extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={css.main_right_content} style={{height: getSize().windowH - 123}}>
                <Scrollbars autoHide>
                    <TestPicturesWall/>
                </Scrollbars>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/xxcj/pictureswall/PicturesWallContainer.js